/**
 * Hook personnalisé pour gérer l'authentification
 */
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Hook pour gérer l'authentification
 * @returns {Object} Fonctions et états liés à l'authentification
 */
const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Vérifier si l'utilisateur est authentifié
  useEffect(() => {
    const checkAuth = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        
        if (!token) {
          setUser(null);
          setLoading(false);
          return;
        }
        
        // Si on a un token, on considère que l'utilisateur est connecté
        if (token) {
          setUser({ id: 1, email: 'user@example.com' }); // Placeholder user
        }
        
        setLoading(false);
      } catch (err) {
        setError(err.message || 'Erreur d\'authentification');
        setLoading(false);
      }
    };
    
    checkAuth();
  }, []);

  // Se connecter
  const login = async (credentials) => {
    try {
      setLoading(true);
      setError(null);
      
      // Simuler une connexion réussie
      const mockUser = { id: 1, email: credentials.email };
      localStorage.setItem('token', 'mock-token-123');
      setUser(mockUser);
      setLoading(false);
      navigate('/dashboard');
      return { success: true, user: mockUser };
    } catch (err) {
      setError(err.message || 'Erreur de connexion');
      setLoading(false);
      throw err;
    }
  };

  // Se déconnecter
  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    navigate('/login');
  };

  return {
    user,
    loading,
    error,
    login,
    logout,
    isAuthenticated: !!user
  };
};

export default useAuth;
